/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} League_Total_CountInputs */



/**
* | output |
* | --- |
* | "{count} league(s)" |
*
* @param {League_Total_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_total_count = /** @type {((inputs: League_Total_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Total_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} ligue(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} liga(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} liga(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} campionato/i`)
	return /** @type {LocalizedString} */ (`${i?.count} league(s)`)
});